import React, { Component } from 'react';
import Switch from 'react-switch';

import Icon from '../../UI/Icons/index';
import classes from './TimeSwitch.css';


class TimeSwitch extends Component {

  handleChange = () => {
    this.props.action();
  }

  render() {
    const activeColor = '#BDD053';
    const notActiveColor = '#464041';
    const sunIcon = (
      <div className={[classes.SwitchIcon, classes.SwitchIconLeft].join(' ')}>
        <Icon
          name="sun"
          height="32"
          width="32"
          fill={this.props.isServiceSelectedEvening ? notActiveColor : activeColor} 
          style={{marginBottom:'3.5px'}}/>
        <span className={this.props.isServiceSelectedEvening ? classes.NotActiveText : classes.ActiveText}>{this.props.translations.label_lunch}</span>
      </div>
    );
    const moonIcon = (
      <div className={[classes.SwitchIcon, classes.SwitchIconRight].join(' ')}>
        <Icon
          name="moon"
          height="24"
          width="24"
          fill={this.props.isServiceSelectedEvening ? activeColor : notActiveColor} 
          style={{marginBottom:'8px'}}/>
        <span className={this.props.isServiceSelectedEvening ? classes.ActiveText : classes.NotActiveText}>{this.props.translations.label_dinner}</span>
      </div>
    );

    return (
        <div className={classes.TimeSwitch}>
          {sunIcon}
          <Switch
            onChange={this.handleChange}
            checked={this.props.isServiceSelectedEvening}
            onColor="#ededed"
            offColor="#ededed"
            onHandleColor="#464041"
            offHandleColor="#464041"
            handleDiameter={36}
            uncheckedIcon={false}
            checkedIcon={false}
            boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
            activeBoxShadow="0px 0px 1px 5px rgba(0, 0, 0, 0.2)"
            height={30}
            width={60}
            className="react-switch" />
          {moonIcon}
        </div>
    );
  }
}

export default TimeSwitch;


// WEBPACK FOOTER //
// ./src/components/TimePicker/TimeSwitch/TimeSwitch.js